<template>
    <div class="flex flex-col gap-0.5 py-3 first:pt-0 last:pb-0">
        <div class="flex items-center gap-2">
            <LeafIcon />
            <span class="font-extrabold" v-text="$t('pages.collection.delivery_options.pickup_point')" />
        </div>
        <span v-safe-html="readableDate" />
    </div>
</template>

<script setup lang="ts">
import LeafIcon from '@/icons/LeafIcon.vue';

defineProps<{
    readableDate: string;
}>();
</script>
